import { Stars } from "@/components/Stars";
import { fmtScore } from "@/lib/api";

const verdict = (avg) => (avg >= 4.5 ? "Eccellente" : avg >= 4 ? "Molto buono" : avg >= 3 ? "Buono" : avg > 0 ? "Sufficiente" : "Nessun voto");

export const ScoreBlock = ({ summary }) => (
  <div data-testid="rating-summary">
    <p className="text-xs uppercase tracking-[0.2em] text-gray-500 font-semibold">Valutazione del negozio</p>
    <div className="mt-4 flex items-end gap-4">
      <span className={`font-display text-7xl sm:text-8xl font-extrabold tracking-tighter leading-none ${summary.count ? "" : "text-gray-300"}`} data-testid="summary-average">
        {fmtScore(summary.average)}
      </span>
      <span className="pb-3 text-gray-500 font-medium">/ 5</span>
    </div>
    <div className="mt-4 flex items-center gap-3 flex-wrap">
      <Stars value={summary.average} size={24} />
      <span className="font-semibold">{verdict(summary.average)}</span>
    </div>
    <p className="mt-2 text-sm text-gray-600" data-testid="summary-count">
      Basato su {summary.count} recensioni verificate del negozio · {summary.product_reviews} sui prodotti
    </p>
  </div>
);

export const Distribution = ({ summary, active, onPick }) => (
  <div className="space-y-2.5" data-testid="rating-distribution">
    {[5, 4, 3, 2, 1].map((n) => {
      const v = summary.distribution?.[n] || 0;
      const pct = summary.count ? (v / summary.count) * 100 : 0;
      return (
        <button
          key={n}
          type="button"
          onClick={() => onPick(active === n ? null : n)}
          data-testid={`distribution-filter-${n}`}
          className={`w-full flex items-center gap-3 text-sm rounded-md px-2 py-1.5 transition-colors duration-150 ${active === n ? "bg-emerald-50" : "hover:bg-gray-50"}`}
        >
          <span className="w-14 text-left font-medium">{n} stelle</span>
          <span className="flex-1 h-2.5 rounded-full bg-gray-100 overflow-hidden">
            <span className="block h-full bg-amber-500 rounded-full transition-[width] duration-700" style={{ width: `${pct}%` }} />
          </span>
          <span className="w-10 text-right text-gray-600 tabular-nums">{v}</span>
        </button>
      );
    })}
  </div>
);
